// extracted by mini-css-extract-plugin
module.exports = {"mobileGuard":"MobileGuard_mobileGuard__3Licr","content":"MobileGuard_content__22y8e","message":"MobileGuard_message__UbUaJ"};